// extracted by mini-css-extract-plugin
module.exports = {"cover":"Cover_cover__15UNi"};